import { gql } from 'apollo-boost';

export const DISMISS_DAILY_REVIEW_SUGGESTION = gql`
    mutation($messageId: ID!) {
        dismissDailyReviewSuggestion(messageId: $messageId)
    }
`;
